import QLOLogo from '../assets/QLOLogoMark.png';

const Preloader = () => {
  return (
    <div className="flex items-center justify-center h-screen w-screen bg-black">
      <img
        src={QLOLogo}
        alt="QLO Logo"
        className="w-96 sm:w-60 md:w-72 animate-pulse"
      />
    </div>
  );
};

export default Preloader;
